module.exports = __webpack_public_path__ + "img/householdequipment4.b7bf947e.png";